var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 6A.75.75 0 0 1 7 5.25h8a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 6zM8 11.25H7a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5zm-1-1.5h4a.75.75 0 0 0 0-1.5H7a.75.75 0 0 0 0 1.5zm9.955 5.5H15.75v-1.285a.75.75 0 0 0-1.5 0V16c0 .414.336.75.75.75h1.955a.75.75 0 0 0 0-1.5zm3.795.75c0 3.17-2.579 5.75-5.75 5.75a5.716 5.716 0 0 1-3.235-1H6A2.752 2.752 0 0 1 3.25 18V5A2.752 2.752 0 0 1 6 2.25h10A2.752 2.752 0 0 1 18.75 5v6.651a5.735 5.735 0 0 1 2 4.349zM6 19.25h4.261A5.71 5.71 0 0 1 9.25 16c0-3.17 2.579-5.75 5.75-5.75a5.72 5.72 0 0 1 2.25.459V5c0-.689-.561-1.25-1.25-1.25H6c-.689 0-1.25.561-1.25 1.25v13c0 .689.561 1.25 1.25 1.25zM19.25 16c0-2.343-1.906-4.25-4.25-4.25s-4.25 1.907-4.25 4.25 1.906 4.25 4.25 4.25 4.25-1.907 4.25-4.25z",
    fill: "#3c0000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogicon);
export default __webpack_public_path__ + "static/media/logicon.e383d20bf9692cd0c751accbdbcda9ed.svg";
export { ForwardRef as ReactComponent };